/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TargetRadialIcon16Light } from './TargetRadialIcon16Light';
import { TargetRadialIcon16Regular } from './TargetRadialIcon16Regular';
import { TargetRadialIcon16Solid } from './TargetRadialIcon16Solid';
import { TargetRadialIcon20Light } from './TargetRadialIcon20Light';
import { TargetRadialIcon20Regular } from './TargetRadialIcon20Regular';
import { TargetRadialIcon20Solid } from './TargetRadialIcon20Solid';
import { TargetRadialIcon24Regular } from './TargetRadialIcon24Regular';
import { TargetRadialIcon24Solid } from './TargetRadialIcon24Solid';
import { TargetRadialIcon32Regular } from './TargetRadialIcon32Regular';
import { TargetRadialIcon64Regular } from './TargetRadialIcon64Regular';
var sizes = {
    16: {
        light: TargetRadialIcon16Light,
        regular: TargetRadialIcon16Regular,
        solid: TargetRadialIcon16Solid,
    },
    20: {
        light: TargetRadialIcon20Light,
        regular: TargetRadialIcon20Regular,
        solid: TargetRadialIcon20Solid,
    },
    24: {
        regular: TargetRadialIcon24Regular,
        solid: TargetRadialIcon24Solid,
    },
    32: {
        regular: TargetRadialIcon32Regular,
    },
    64: {
        regular: TargetRadialIcon64Regular,
    },
};
export var TargetRadialIcon = forwardRef('TargetRadialIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
